import {Distribution, _Distribution} from './distribution';

/**
 * Generated from com.dataiku.dip.eda.compute.distributions.Laplace
 */
export interface Laplace extends _Distribution {
    // PolyJson type
    type: 'laplace';
}

export function isLaplace(toTest: Distribution): toTest is Laplace { return 'laplace' === toTest.type; }

export namespace Laplace {
    /**
     * Generated from com.dataiku.dip.eda.compute.distributions.Laplace$FittedLaplace
     */
    export interface FittedLaplace extends Distribution._FittedDistribution {
        b: number;
        mu: number;

        // PolyJson type
        type: 'laplace';
    }

    export function isFittedLaplace(toTest: Distribution.FittedDistribution): toTest is FittedLaplace { return 'laplace' === toTest.type; }
}